/**
 * Gameplay Constants
 * 
 * Centralized game mechanics, thresholds, and limits
 */

// Score Thresholds
export const SCORE_THRESHOLDS = {
  PERFECT: 100,
  EXCELLENT: 90,
  GOOD: 70,
  NEEDS_IMPROVEMENT: 60,
  POOR: 50
};

// Scoring System
export const SCORING = {
  POINTS_PER_CORRECT: 10,
  POINTS_DIVISOR: 10,      // Used to calculate correct answers from score
  PERFECT_SCORE: 100,
  PERCENTAGE_MULTIPLIER: 100  // Used to convert decimal to percentage
};

// Achievement Thresholds
export const ACHIEVEMENT_THRESHOLDS = {
  FIRST_QUESTIONS: 1,
  MARATHON_RUNNER: 50,
  SCHOLAR: 5,
  PERFECTIONIST: 3,
  SUBJECT_MASTER: 1,
  HUNDRED_QUESTIONS: 100
};

// Question Limits
export const QUESTION_LIMITS = {
  MIN: 1,
  MAX: 100,
  DEFAULT: 10
};

// Progress Thresholds
export const PROGRESS_THRESHOLDS = {
  SUBJECTS_EXCELLENT: 8,
  SUBJECTS_GOOD: 5,
  PERCENTAGE_EXCELLENT: 90,
  PERCENTAGE_GOOD: 70
};

// Unlock Thresholds (for themes/avatars)
export const UNLOCK_THRESHOLDS = {
  OCEAN_THEME: 3,        // Complete 3 subjects
  FOREST_THEME: 5,       // Get 5 perfect scores
  SPACE_THEME: 100,      // Answer 100 questions
  ROBOT_AVATAR: 2,       // Complete 2 subjects
  PRINCESS_AVATAR: 3,    // Get 3 perfect scores
  SUPERHERO_AVATAR: 50,  // Answer 50 questions
  ASTRONAUT_AVATAR: 7    // Complete 7 subjects
};

// Achievement Points (used in achievement definitions)
export const ACHIEVEMENT_POINTS = {
  FIRST_STEPS: 10,
  PERFECT_SCORE: 50,
  SUBJECT_MASTER: 100,
  SCHOLAR: 150,
  PERFECTIONIST: 200,
  MARATHON_RUNNER: 100,
  STREAK_MASTER: 200,
  EARLY_BIRD: 25,
  NIGHT_OWL: 25,
  GRAND_MASTER: 500
};

// Reward Points (legacy - keeping for backward compatibility)
export const REWARD_POINTS = ACHIEVEMENT_POINTS;

// Time Thresholds (for achievements)
export const TIME_THRESHOLDS = {
  EARLY_BIRD_START: 5,
  EARLY_BIRD_END: 8,
  NIGHT_OWL_START: 20
};

// Rating System
export const RATING = {
  MIN: 1,
  MAX: 5,
  DEFAULT: 5
};

// Recent Scores Tracking
export const RECENT_SCORES_MIN_COUNT = 3;

// Network Retry Configuration
export const NETWORK_RETRY = {
  MAX_RETRIES: 3,
  BASE_DELAY: 1000
};
